<template>
  <div class="mb-24px" v-if="images.length > 0">
    <template v-if="images.length == 1">
      <picture class="image">
        <source
          media="(min-width: 768px)"
          :srcset="`${images[0].main.url}&w=768&h=1920, ${images[0].main.url}&w=1152&h=2880 1.5x`"
        />
        <img :src="`${images[0].main.url}&w=768&h=1920`" :alt="images[0].main.alt" />
      </picture>
      <prismic-rich-text
        v-if="$prismicText(images[0].caption)"
        class="content mt-8px mb-0 is-size-7"
        :field="images[0].caption"
      />
    </template>
    <template v-else>
      <b-carousel :autoplay="false" :indicator="false" :arrow-hover="false">
        <b-carousel-item v-for="(image, index) in images" :key="index">
          <picture class="image is-4by3">
            <source
              media="(min-width: 768px)"
              :srcset="`${image.carousel.url}&w=768&h=1920, ${image.carousel.url}&w=1152&h=2880 1.5x`"
            />
            <img :src="`${image.carousel.url}&w=768&h=1920`" :alt="image.carousel.alt" />
          </picture>
          <prismic-rich-text v-if="$prismicText(image.caption)" class="content mt-8px mb-0 is-size-7" :field="image.caption" />
        </b-carousel-item>
      </b-carousel>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    fragment: Object
  },
  computed: {
    images() {
      return this.fragment.items
        .filter((x) => x.image_media && x.image_media.url)
        .map((x) => {
          return {
            caption: x.image_caption,
            main: {
              url: this.removeUrlWidthHeight(x.image_media.url),
              alt: x.image_media.alt || ''
            },
            carousel: {
              url: this.removeUrlWidthHeight(
                x.image_media.carousel && x.image_media.carousel.url ? x.image_media.carousel.url : x.image_media.url
              ),
              alt: x.image_media.carousel && x.image_media.carousel.alt ? x.image_media.carousel.alt : ''
            }
          }
        })
    }
  },
  methods: {
    removeUrlWidthHeight(url) {
      return url.replace(/[?&][wh]=[0-9]+/g, '')
    }
  }
}
</script>
